import { usePostRequest } from "../usePostRequest";
import { TERMS_AND_CONDITIONS_API } from "./useTermsAndConditionsQuery";

type useTermsAndConditionsMutationArgs = void;

type useTermsAndConditionsMutationResponse = { tcAccepted: boolean };

export const useTermsAndConditionsMutation = () => {
  return usePostRequest<
    useTermsAndConditionsMutationResponse,
    useTermsAndConditionsMutationArgs
  >(TERMS_AND_CONDITIONS_API);
};
